export interface CustomerInterface {
    ctm_id: number
    ctm_name1: string | null
    ctm_name2: string | null
    ctm_pronunciation1: string | null
    ctm_pronunciation2: string | null
    ctm_address1: string | null
    ctm_address2: string | null
    ctm_address3: string | null
    ctm_birthday: string | null
    ctm_gender: string | null
    ctm_mail1: string | null
    ctm_mail2: string | null
    ctm_postcode: string | null
    ctm_tel1: string | null
    ctm_tel2: string | null
    delete_flug: string | null
    visitor_flug: string | null
    code?: string | null
    join_date?: string | null
    old_member_id?: string | null
    point?: number | null
    renew_date?: string | null
    sum_cancel_charge?: string | null
    validity_date?: string | null
}

export interface AdjustmentInterface {
    adj_reg_date: string
    adj_reg_stfid: number
    adjdtl_id: number
    adjsht_id: number
    apiece: number
    ccsht_id: number | null
    charge: number
    comment: string
    cpuse_id: number | null
    cshitm_id: number
    cshitm_name: string
    ctm_id: number
    delete_flug: string
    equrv_id: number | null
    extra: string | null
    is_settled: string
    item_number: number
    settled_date: string
    stdrv_id: number | null
    str_id: number
    str_name: string
}

export interface CustomerDetailInterface extends CustomerInterface {
    cancel_charge_list: Object[]
    ctm_memo: Object
    membership_adjustment_list: Map<number, AdjustmentInterface>
    mypage_flug: string
}

export interface CustomerMemo {
    ctmmm_id: number
    ctm_memo: string
}
export function ObjectToCustomerMemo(obj: any): CustomerMemo {
    return {
        ctmmm_id: parseInt(obj[0]),
        ctm_memo: obj[1]
    }
}